import axios from "axios";
import moment from "moment-timezone";
import { Routes } from "./classes/Routes";
import { auth } from "./firebase";

const hostname = window && window.location && window.location.hostname;

let apiPath = "/";
let withCredentials = false;
if (hostname === "localhost") {
  apiPath = "http://localhost:8080/";
  withCredentials = true;
}

const instance = axios.create({
  baseURL: apiPath,
  withCredentials: withCredentials,
});

instance.interceptors.request.use(async (config) => {
  const firebaseToken = await auth.currentUser?.getIdToken();
  config.headers["X-Auth"] = `Bearer ${firebaseToken ? firebaseToken : ""}`;
  config.headers["X-TimeZoneName"] = moment.tz.guess();
  return config;
});

instance.interceptors.response.use(
  (config) => config,
  (error) => {
    if (axios.isCancel(error)) {
      return Promise.reject(error);
    }
    let response = error?.response;
    if (!response) {
      response = { data: "Server error! Please contact support.", status: 503 };
    } else if (response.status === 500 || response.status === 405) {
      response.data = "Server error! Please contact support.";
    }
    if (response && response.status === 401) {
      if (window.location.pathname !== Routes.LOGIN) {
        window.location.href = `${Routes.LOGIN}${window.location.search}`;
      }
    }
    return Promise.reject({ response });
  }
);

export default instance;
